import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Col, Form, Modal, Row, Button } from 'react-bootstrap'
import { ImCross } from 'react-icons/im'
import { toast } from 'react-toastify'
import { WebApiCalls } from '../../../webApiCalls/WebApiCalls'
import { useAuth } from '../../../hooks/useAuth'
const RewardEditModal = (props) => {
    const {getToken}=useAuth()
    const { data, handleClose, show, getAllRewards, offset } = props
    const [id, setId] = useState('')
    const [name, setName] = useState('')
    const [allowRedeems, setAllowRedeems] = useState(0)
    const [reqPoints, setReqPoints] = useState(0)
    const [description, setDescription] = useState('')
    const [validity, setValidity] = useState('')
    const [status, setStatus] = useState('active')

    useEffect(() => {
        setId(data?._id)
        setName(data?.name)
        setAllowRedeems(data?.noOfAllowRedeems)
        setStatus(data?.status)
        setReqPoints(data?.requiredPoints)
        setValidity(data?.validity)
        setDescription(data?.description)
    }, [data])

    const handleSubmit = async (e) => {
        e.preventDefault()
        handleClose()
        const obj = {
            name,
            validity,
            description,
            status,
            requiredPoints: reqPoints,
            noOfAllowRedeems: allowRedeems,
        }
        const token =getToken()
        if (token && id) {
            new WebApiCalls().updateReward(token, obj, id)
                .then(res => {
                    if (res?.code == 200) {
                        toast.success("Reward Details are updated successfully")
                        getAllRewards(offset)
                    }
                    else {
                        toast.error("Oops...! Something went wrong.")
                    }
                })
                .catch(err => { })
        }
    }


    return (
        <Modal
            size="lg"
            show={show}
            onHide={(e) => handleClose(e)}
            aria-labelledby="example-modal-sizes-title-lg"
            centered
        >
            <Form onSubmit={(e) => handleSubmit(e)}>
                <Modal.Header className='px-0'>
                    <Modal.Title className='modal-title px-4' id="example-modal-sizes-title-lg">
                        Edit Reward Detail
                    </Modal.Title>
                    <button className="modal-close-btn me-4 text-center" onClick={e => {
                        e.preventDefault()
                        handleClose()

                    }}>
                        <ImCross color='#fff' size={12} />
                    </button>
                </Modal.Header>
                <Modal.Body className='px-4 justify-content-center'>
                    <Row className="mx-2">

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Name</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="text"
                                    value={name} onChange={e => setName(e.target.value)}
                                    placeholder="Name here" required />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Number of Allow Redeems</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="number" min={0}
                                    value={allowRedeems} onChange={(e) => setAllowRedeems(e.target.value)}
                                    placeholder="Number of Allow Redeems" required
                                />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Required Points</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="number" min={0}
                                    value={reqPoints} onChange={e => setReqPoints(e.target.value)}
                                    placeholder="Required Points" required />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Validity</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="datetime-local"
                                    value={validity} onChange={e => setValidity(e.target.value)}
                                    placeholder="Validity" required />
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Status</div>
                            <div className='mt-2'>
                                <select className='status-selector' value={status} onChange={(e) => {
                                    setStatus(e.target.value)

                                }}>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                        </Col>

                        <Col md={6} className="mb-4">
                            <div className='modal-small-heading'>Description</div>
                            <div className='mt-2'>
                                <input className="edit-modal-input" type="text"
                                    value={description} onChange={e => setDescription(e.target.value)}
                                    placeholder="Description here" required
                                />
                            </div>
                        </Col>
                    </Row>

                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-center'>
                    <Button type="submit" className='default-btn save-btn' onClick={(e) => handleSubmit(e)}>SAVE</Button>
                </Modal.Footer>
            </Form>
        </Modal >
    )
}

export default RewardEditModal